<h1 mat-dialog-title>Info</h1>
  <div mat-dialog-content>
    <p>{{ data.infoMessage }}<p>
    <p *ngIf="data.infoDetail">{{ data.infoDetail }}<p>
    <div class="html-preview" *ngIf="data.infoHtmlDetail" [innerHtml]="data.infoHtmlDetail"><div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
  </div>


// WEBPACK FOOTER //
// ./src/app/private/private.component.ts.AppInfoDialogComponent.html